<template>
  <IconButton bgColor="#16AFC7" width="9.8em" :svg="$assets.svg.video_icon" @click="click"> View Video </IconButton>
</template>

<script>
import IconButton from '@/components/events/IconButton.vue';

export default {
  props: {
    evEventOrCourse: {
      type: Object,
      default: () => ({}),
    },
  },

  computed: {
    isProfessionalEvent() {
      return this.evEventOrCourse.type_code === 'PROFESSIONAL';
    },
  },

  components: {
    IconButton,
  },

  methods: {
    click() {
      if (this.isProfessionalEvent) {
        this.$router.push({
          name: 'course',
          params: { eventId: this.evEventOrCourse.id },
        });
        return;
      }

      window.open(this.evEventOrCourse.video_link, '_blank');
    },
  },
};
</script>
